
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class extends Vue {
  @Prop({ default: [] }) levelList!: []; // 成长等级列表

  @Prop({ default: [] }) growthRuleList!: []; // 成长规则列表

  // @Prop({ default: [] }) ruleList!: []; // 积分规则列表
}
